import image6 from "../assets/images/brown-file-board.png";
import RigidBox from "../assets/images/Products/ridgid_box.jpeg";
import Jewellery_Box_Board from "../assets/images/Products/jwellery.jpeg";
import Calendar_Box_Board from "../assets/images/Products/calender.avif";
import Calendar_Box_Board1 from "../assets/images/Products/calender.avif";
import Table_calander_board from "../assets/images/Products/calender2.jpeg";
import Sweet_Box_Board from "../assets/images/Products/Sweet.jpeg";
import Sweet_Box_Board1 from "../assets/images/Products/Sweet1.jpeg";
import Sweet_Box_Board2 from "../assets/images/Products/Sweet3.jpeg";
import Diary_Black_Board from "../assets/images/Products/diary1.jpeg";
import Diary_Black_Board1 from "../assets/images/Products/diary2.jpeg";
import Wallet_Box_Board from "../assets/images/Products/Top_black.jpeg";
import Notebook from "../assets/images/Products/NoteBook.jpeg";
import Arabic_Notebook from "../assets/images/Products/Arabic_notebook.png";
import Both_Side_white from "../assets/images/Products/both_side_white.jpeg";
import Mobile_Box_Board from "../assets/images/Products/both_side_white.jpeg";
import Bakery_Packing_Board from "../assets/images/Bakery_Packing_Board.png";
import LWC_Coated_Board from "../assets/images/LWC_Coated_Board.png";
import White_Black_Board from "../assets/images/White_Black_Board.png";
import Exam_Pad from "../assets/images/Exam_Pad.png";
import Bazzles from "../assets/images/Bazzles.png";

const products = [
  {
    id: 1,
    name: "Ridgid Box",
    category: "Hi tech board",
    price: 120,
    image: RigidBox,
    details: {
      "Shape" : "Customised",
      "Grammages" : "570 – 2500 GSM",
      "Thickness" : " 0.9 mm to 4.0 mm",
      "Finish" : "  Smooth",
      "Material" : "Kappa board",
      "Colour" : "Grey, black , white",
      "Size" : "Customised"
    }
  },
  {
    id: 2,
    name: "Brown Paper File board",
    category: "Paper File Board",
    price: 120,
    image: image6,
    details: {
      "Shape" : "Customised",
      "Grammages" : "570 – 2500 GSM",
      "Thickness" : " 0.9 mm to 4.0 mm",
      "Finish" : "  Smooth",
      "Material" : "Kappa board",
      "Colour" : "Grey",
      "Size" : "Customised"
    }
  },
  {
    id: 3,
    name: "Jewellery Box",
    category: "Hi tech board",
    price: 150,
    image: Jewellery_Box_Board,
    details: {
      "Shape" : "Customised",
      "Grammages" : "570 – 2500 GSM",
      "Thickness" : " 0.9 mm to 4.0 mm",
      "Finish" : "  Smooth",
      "Material" : "Kappa board",
      "Colour" : "Grey, black ",
      "Size" : "Customised"
    }
  },
  {
    id: 4,
    name: "Table Calendar",
    category: "Hi tech top maplitho",
    price: 200,
    images: [Table_calander_board,Calendar_Box_Board1],
    details: {
      "Shape" : "Customised",
      "Grammages" : "570 – 2500 GSM",
      "Thickness" : " 0.9 mm to 4.0 mm",
      "Finish" : "  Smooth",
      "Material" : "Kappa board",
      "Colour" : "white",
      "Size" : "Customised"
    }
  },
  {
    id: 5,
    name: "Mobile Box",
    category: "Hi tech top maplitho",
    price: 180,
    image: Mobile_Box_Board,
    details: {
      "Shape" : "Customised",
      "Grammages" : "570 – 2500 GSM",
      "Thickness" : " 0.9 mm to 4.0 mm",
      "Finish" : "  Smooth",
      "Material" : "Kappa board",
      "Colour" : "white",
      "Size" : "Customised"
    }
  },
  {
    id: 6,
    name: "Wallet Box",
    category: "Hi tech top black",
    price: 220,
    image: Wallet_Box_Board,
    details: {
      "Shape" : "Customised",
      "Grammages" : "570 – 2500 GSM",
      "Thickness" : " 0.9 mm to 4.0 mm",
      "Finish" : "  Smooth",
      "Material" : "Kappa board",
      "Colour" : "black",
      "Size" : "Customised"
    }
  },
  {
    id: 7,
    name: "Arabic Notebook",
    category: "Hi tech top black",
    price: 250,
    image: Arabic_Notebook,
    details: {
      "Shape" : "Customised",
      "Grammages" : "570 – 2500 GSM",
      "Thickness" : " 0.9 mm to 4.0 mm",
      "Finish" : "  Smooth",
      "Material" : "Kappa board",
      "Colour" : "black , white",
      "Size" : "Customised"
    }
  },
  {
    id: 8,
    name: "Calendar Board",
    category: "Hi tech Supreme Grey",
    price: 170,
    image: Calendar_Box_Board,
    details: {
      "Shape" : "Customised",
      "Grammages" : "570 – 2500 GSM",
      "Thickness" : " 0.9 mm to 4.0 mm",
      "Finish" : "  Smooth",
      "Material" : "Kappa board",
      "Colour" : "Grey",
      "Size" : "Customised"
    }
  },
  {
  id: 9,
  name: "Sweet Box",
  category: "Hi Tech top PE Coated",
  price: 190,
  images: [Sweet_Box_Board, Sweet_Box_Board1, Sweet_Box_Board2], // Multiple images
  details: {
    "Shape": "Customised",
    "Grammages": "570 – 2500 GSM",
    "Thickness": "0.9 mm to 4.0 mm",
    "Finish": "Smooth",
    "Material": "Kappa board",
    "Colour": "Grey",
    "Size": "Customised"
  }
},
  {
    id: 10,
    name: "Bakery Packing",
    category: "Hi Tech top PE Coated",
    price: 210,
    image: Bakery_Packing_Board,
    details: {
      "Shape" : "Customised",
      "Grammages" : "570 – 2500 GSM",
      "Thickness" : " 0.9 mm to 4.0 mm",
      "Finish" : "  Smooth",
      "Material" : "Kappa board",
      "Colour" : "Grey",
      "Size" : "Customised"
    }
  },
  {
    id: 11,
    name: "Both Side White",
    category: "Both Side White",
    price: 230,
    image: Both_Side_white,
    details: {
      "Shape" : "Customised",
      "Grammages" : "570 – 2500 GSM",
      "Thickness" : " 0.9 mm to 4.0 mm",
      "Finish" : "  Smooth",
      "Material" : "Kappa board",
      "Colour" : "Grey, black , white, ",
      "Size" : "Customised"
    }
  },
  {
    id: 12,
    name: "White & Black Board",
    category: "Hi Tech Both Side WHITE & BLACK",
    price: 260,
    image: White_Black_Board,
    details: {
      "Shape" : "Customised",
      "Grammages" : "570 – 2500 GSM",
      "Thickness" : " 0.9 mm to 4.0 mm",
      "Finish" : "  Smooth",
      "Material" : "Kappa board",
      "Colour" : "black , white ",
      "Size" : "Customised"
    }
  },
  {
    id: 14,
    name: "Notebook",
    category: "Hi tech board",
    price: 80,
    image: Notebook,
    details: {
      "Shape" : "Customised",
      "Grammages" : "570 – 2500 GSM",
      "Thickness" : " 0.9 mm to 4.0 mm",
      "Finish" : "  Smooth",
      "Material" : "Kappa board",
      "Colour" : "Grey",
      "Size" : "Customised"
    }
  },
  {
    id: 15,
    name: "Diary",
    category: "Hi tech board",
    price: 100,
    images: [Diary_Black_Board,Diary_Black_Board1],
    details: {
      "Shape" : "Customised",
      "Grammages" : "570 – 2500 GSM",
      "Thickness" : " 0.9 mm to 4.0 mm",
      "Finish" : "  Smooth",
      "Material" : "Kappa board",
      "Colour" : "Grey",
      "Size" : "Customised"
    }
  },
  {
    id: 16,
    name: "Exam Pad",
    category: "Hi tech Supreme Grey",
    price: 60,
    image: Exam_Pad,
    details: {
      "Shape" : "Customised",
      "Grammages" : "570 – 2500 GSM",
      "Thickness" : " 0.9 mm to 4.0 mm",
      "Finish" : "  Smooth",
      "Material" : "Kappa board",
      "Colour" : "Grey",
      "Size" : "Customised"
    }
  },
];

export default products;